/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AgentDetails = {
    agentType?: AgentDetails.agentType;
    freeMemoryInBytes?: number;
    numberOfWorkerThreads?: number;
    osArchitecture?: string;
    osHostName?: string;
    osName?: string;
    osVersion?: string;
};

export namespace AgentDetails {

    export enum agentType {
        CLASSIC = 'CLASSIC',
        SNOWFLAKE_NATIVE_APP = 'SNOWFLAKE_NATIVE_APP',
    }


}
